export const SHIPMENT_STATUS = {
  PREPARING_SHIPMENT: "preparingShipment",
  SHIPPED: "shipped",
} as const;
